<template>
    <div>
        <tx-events v-bind:address="address" v-if="currentComponent === 'tx-events'"
            v-on:lastActivityUpdate="handleNestedActivityUpdate"
            v-bind:shouldLoadPendings="shouldLoadPendings"
        />

        <tx-history v-bind:address="address" v-if="currentComponent === 'tx-history'" />

        <tx-simple v-bind:address="address" v-if="currentComponent === 'tx-simple'"
            v-bind:shouldLoadPendings="shouldLoadPendings"
            v-on:updateBalance="handleNestedBalanceUpdate"
        />
    </div>
</template>

<script>
import TxEvents from './TxEvents.vue';
import TxHistory from './TxHistory.vue';
import TxSimple from './TxSimple.vue';

export default {
    name: 'tx-root',
    props: {
        address: {
            type: String,
            required: false,
        },
        shouldLoadPendings: {
            type: Boolean,
        },
    },

    data() {
        return {
            currentComponent: undefined,
        };
    },

    components: {
        TxEvents,
        TxHistory,
        TxSimple,
    },

    mounted() {
        this.updateCurrentComponent(this.$store.state.transactionViewData);
    },

    watch: {
        '$store.state.transactionViewData': function (newVal) {
            this.updateCurrentComponent(newVal);
        },
    },

    methods: {
        // updateFilterShow(value) {
        //     this.$store.commit('updateFilterShow', value);
        // },

        // handleTabNameChange(tabName) {
        //     if (tabName === 'events') {
        //         this.updateFilterShow(true);
        //     } else {
        //         this.updateFilterShow(false);
        //     }
        // },

        updateCurrentComponent(value) {
            if (value === 'alternative') {
                this.currentComponent = 'tx-events';
            } else if (value === 'professional') {
                this.currentComponent = 'tx-history';
            } else if (value === 'simple') {
                this.currentComponent = 'tx-simple';
            }
        },

        handleNestedActivityUpdate(data) {
            this.$emit('lastActivityUpdate', data);
        },

        handleNestedBalanceUpdate(data) {
            this.$emit('updateBalance', data);
        },
    },
};
</script>
